var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetrolPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2181 10.81L41.2565 10.7717L31.737 1.27782L29.0281 3.98667L34.4203 9.37885C32.0181 10.2988 30.3058 12.6117 30.3058 15.3333C30.3058 18.86 33.168 21.7222 36.6947 21.7222C37.6019 21.7222 38.4708 21.5305 39.2502 21.1855V39.611C39.2503 41.0167 38.1003 42.1667 36.6948 42.1667C35.2893 42.1667 34.1393 41.0167 34.1393 39.6111V28.1112C34.1393 25.2873 31.8521 23 29.0281 23H26.4726V5.11115C26.4725 2.28718 24.1853 0 21.3615 0H6.02814C3.20417 0 0.916992 2.28718 0.916992 5.11115V46H26.4725V26.8333H30.3058V39.6111C30.3058 43.1378 33.168 46 36.6947 46C40.2214 46 43.0835 43.1378 43.0835 39.6111V15.3333C43.0837 13.57 42.3681 11.9728 41.2181 10.81ZM21.3615 17.8888H6.02814V5.11115H21.3615V17.8888ZM36.6948 17.8888C35.2893 17.8888 34.1393 16.7388 34.1393 15.3333C34.1393 13.9278 35.2893 12.7778 36.6948 12.7778C38.1003 12.7778 39.2503 13.9278 39.2503 15.3333C39.2503 16.7388 38.1003 17.8888 36.6948 17.8888Z",
    fill: "url(#paint0_linear_0_3707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3707",
    x1: 3.77929,
    y1: -4.51786,
    x2: 46.0275,
    y2: -1.87356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrolPump);
export default __webpack_public_path__ + "static/media/petrol-pump.ae75b816420500e88cdf8dda2e893714.svg";
export { ForwardRef as ReactComponent };